import React from 'react';
import { Container, Typography, List, ListItem, Link, Box } from '@mui/material';

function Education() {
    // 授業リストとリンク
    const undergraduate_courses = [
        {
            name: "Numerical Analysis (internal access only)",
            link: "https://web-int.u-aizu.ac.jp/~nisidate/na",
        },
        {
            name: "Computer Graphics (internal access only)",
            link: "https://web-int.u-aizu.ac.jp/~fayolle/teaching/cg/index.html",
        },
        {
            name: "Integrated Exercises for Software I (internal access only, moodle)",
            link: "https://elms.u-aizu.ac.jp/login/index.php",
        },
        {
            name: "Operating Systems, Exercise for C2 (internal access only, moodle)",
            link: "https://elms.u-aizu.ac.jp/login/index.php",
        },
        {
            name: "SCCP: Computer Science Summer Camp Courseware Development",
            link: "https://web-int.u-aizu.ac.jp/~nisidate/CSSC",
        },
    ];

    const graduate_courses = [
        {
            name: "Finite Element Modeling and Visualization (internal access only, moodle)",
            link: "https://elms.u-aizu.ac.jp/login/index.php",
        },
    ];

        // 模擬授業用講義資料
    const demoLectureMaterials = [
        {
            name: "模擬授業: 2026 いわき総合高校  (internal access only)",
            link: "https://web-int.u-aizu.ac.jp/~nisidate/tmp/demo.pdf",
        },
        // // 必要に応じて項目を追加
    ];

    // 現在の所属学生と研究テーマ
    const currentStudents = [
        {
            name: "Yuya Kawamura",
            degree: "M.S.",
            theme: "Geometry-Driven Selectivity in Macrocyclization via Rigid-Body Simulation",
        },
        {
            name: "Koki Okumura",
            degree: "B.S.",
            theme: "Visualization for Understanding Human Activity",
        },
        {
            name: "Takuma Honda",
            degree: "B.S.",
            theme: "VR for Historical Sites",
        },
        {
            name: "Yuki Tahara",
            degree: "B.S.",
            theme: "TBD",
        },        
        {
            name: "Yudai Ishizuka",
            degree: "B.S.",
            theme: "TBD",
        },        
        {
            name: "Kanji Ikarashi",
            degree: "B.S.",
            theme: "TBD",
        },        
    ];

    // 過去の卒業生 - Ph.D. Thesis
    const phdAlumni = [

    ];

    // 過去の卒業生 - Master Thesis
    const masterAlumni = [
        {
            name: "Megumi Takato",
            year: 2020,
            theme: "Crack Generation by L-system toward Visually Convincing Fracture Animation",
            thesisLink: "",
        },
        {
            name: "Takuya Saito",
            year: 2016,
            theme: "Augmented Reality system for interactive control of 3D objects",
            thesisLink: "",
        },
        {
            name: "Fumiya Tajima",
            year: 2016,
            theme: "Virtual Object Blurring for Realistic Augmented Reality based on Camera Parameters",
            thesisLink: "",
        },
        {
            name: "Hikaru Abe",
            year: 2016,
            theme: "WebVR Application of Floor Guidance with Head Gestures Recognized by Smartphone Sensors",
            thesisLink: "",
        },
    ];

    // 過去の卒業生 - Graduation Thesis
    const bachelorAlumni = [
        {
            name: "Yuya Kawamura",
            year: 2026,
            theme: "Geometry-Driven Selectivity in Macrocyclization via Rigid-Body Simulation",
        },
        {
            name: "Shinpei Yokoyama",
            year: 2026,
            theme: "Photogrammetry-Based Reconstruction of Tsurugajo Castle with CAD Refinement for Real-Time Visualization in Unity ",
        },
        {
            name: "Taichi Sasaki",
            year: 2025,
            theme: "Application of Texture Mapping Techniques for Efficient Rendering of Tsuruga-jo 3D Model in VR environment",
        },
        {
            name: "Shin Sakakibara",
            year: 2025,
            theme: "Evaluating Performances of Swarm Intelligence Algorithms for Global Optimization",
        },
        {
            name: "Ryusei Kazama",
            year: 2024,
            theme: "Evaluating the performance of object detection methods",
        },
        {
            name: "Nao Okada",
            year: 2024,
            theme: "Virtual Tsuruga-jo Streetscape for Enhanced Sightseeing Experiences",
        },
        {
            name: "Kazuki Uchida",
            year: 2023,
            theme: "Comparisons of Unity and Unreal Engine for Rigid Body Dynamics",
        },
        {
            name: "Naoya Matsuda",
            year: 2022,
            theme: "Augmented Reality Visualization of Virtual Furniture Placements through Interactive Communication with Friends",
        },
        {
            name: "Yasunori Katano",
            year: 2022,
            theme: "A Comparison of Maze Generation Algorithms in Simple Quality Measures",
        },
        {
            name: "Mizuki Sonobe",
            year: 2022,
            theme: "An Experimental Comparison of Haar Cascade Clas-sifiers for Detecting Faces Wearing a Mask",
        },
        {
            name: "Yusuke Sato",
            year: 2021,
            theme: "Measuring the distance between objects in an image using a monocular camera",
        },
        {
            name: "Kotaro Tanno",
            year: 2021,
            theme: "A  comparison  of  visual  quality  and  overhead  of hair rendering methods",
        },
        {
            name: "Satsuki Inoue",
            year: 2021,
            theme: "Comparison  of  Top-down  and  Bottom-up  Construction of Bounding Volume Hierarchy for Raytracing",
        },
        {
            name: "Naoki Ichinose",
            year: 2021,
            theme: "A navigation system for tourists using augmented reality technology",
        },
        {
            name: "Momoko Hoshi",
            year: 2020,
            theme: "Computational Modeling and Visualization of Single-walled Carbon Nanotubes",
        },
        {
            name: "Ryosuke Suzuki",
            year: 2020,
            theme: "Ray-tracing with Ambient Occlusion",
        },
        {
            name: "Kotaro Fukamizu",
            year: 2020,
            theme: "Fluid  Simulations  by  Smoothed  Particle Hydrodynamics",
        },
        {
            name: "Yuji Takagi",
            year: 2020,
            theme: "Modeling of Effects of Obstacles on Two-dimensional Wave Propagation",
        },
        {
            name: "Shinya Watahiki",
            year: 2020,
            theme: "Comparison of operability in VR",
        },
        {
            name: "Yuto Tsukui",
            year: 2019,
            theme: "Equivalent circuit simulation of THz detectors based on HEMT-like structures",
        },
        {
            name: "Hiroto Yokoyama",
            year: 2019,
            theme: "A Comparison of Ray Tracing Rendering Algorithms using GPU",
        },
        {
            name: "Naoto Kageyama",
            year: 2019,
            theme: "Improving Intuitivity of Controlling Virtual Objects by Hand-Gesture",
        },
        {
            name: "Yuji Tamakawa",
            year: 2018,
            theme: "An AR Navigation System for Android by Wikitude SDK",
        },
        {
            name: "Megumi Takato",
            year: 2018,
            theme: "Generating Crack Patterns on Planar Geometry by Lsystem",
        },
        {
            name: "Kohei Higuchi",
            year: 2018,
            theme: "Performance Comparisons of Various APIs Imple-mentation in Ray tracing",
        },
        {
            name: "Takamichi Suzuki",
            year: 2018,
            theme: "Developing the AR Application for English Vocabulary Learning",
        },
        {
            name: "Kei Kato",
            year: 2018,
            theme: "Darts Play Application in Virtual Reality",
        },
        {
            name: "Yuichi Nakata",
            year: 2017,
            theme: "A Rigid Body Dynamics Simulator using WebGL",
        },
        {
            name: "Masato Yabe",
            year: 2017,
            theme: "Sand flow simulation using SPH",
        },
        {
            name: "Ryota Kanai",
            year: 2017,
            theme: "Smoothed Particle Hydrodynamics Method and Marching Cubes Method for Visualization of Water",
        },
        {
            name: "Kazuya Akutsu",
            year: 2017,
            theme: "Navigation System using Augmented Reality Technology for Android Platforms",
        },
        {
            name: "Tatsumi Nitsuma",
            year: 2016,
            theme: "AR System with a Denoising Procedure for Stabilized Control of 3D Objects by Fingers",
        },
        {
            name: "Keishi Chida",
            year: 2016,
            theme: "Ray marching simulation in real time by WebGL",
        },
        {
            name: "Joji Ikarashi",
            year: 2016,
            theme: "Creation of a 3D map using Fundamental Geospatial Data",
        },
        {
            name: "Yusuke Ito",
            year: 2016,
            theme: "Development of a rigid body simulator for various 3D objects by WebGL",
        },
        {
            name: "Shuichiro Murata",
            year: 2015,
            theme: "Constructing the Sierpinski Gasket and Its Visualization as Computer Graphics",
        },
        {
            name: "Takeru Hirano",
            year: 2015,
            theme: "Bump mapping and displacement mapping techniques and comparisons of their computational loading",
        },
        {
            name: "Junta Muramatsu",
            year: 2015,
            theme: "Street view by WebGL with simple graphical user interfaces",
        },
        {
            name: "Ryo Namekata",
            year: 2014,
            theme: "Street View by WebGL",
        },
        {
            name: "Fumiya Tajima",
            year: 2014,
            theme: "An adaptive element subdivision algorithm for efficient finite element analysis",
        },
        {
            name: "Hikaru Abe",
            year: 2014,
            theme: "Performance Comparison of WebGL and OpenGL in 3DCG Rigid Body Simulation",
        },        
    ];

    return (
        <Container>

            {/* 授業リスト */}
            <Box mb={4}>
                <Typography variant="h6" gutterBottom>
                    Undergraduate Courses
                </Typography>
                <List>
                    {undergraduate_courses.map((course, index) => (
                        <ListItem key={index} sx={{ padding: 0, marginBottom: '4px' }}>
                            <Typography variant="body2">
                                <Link href={course.link} target="_blank" rel="noopener noreferrer">
                                    {course.name}
                                </Link>
                            </Typography>
                        </ListItem>
                    ))}
                </List>

                <Typography variant="h6" gutterBottom>
                    Graduate School Courses
                </Typography>
                <List>
                    {graduate_courses.map((course, index) => (
                        <ListItem key={index} sx={{ padding: 0, marginBottom: '4px' }}>
                            <Typography variant="body2">
                                <Link href={course.link} target="_blank" rel="noopener noreferrer">
                                    {course.name}
                                </Link>
                            </Typography>
                        </ListItem>
                    ))}
                </List>

                <Typography variant="h6" gutterBottom>
                    Demo Lecture Materials
                </Typography>
                <List>
                    {demoLectureMaterials.map((item, index) => (
                        <ListItem key={index} sx={{ padding: 0, marginBottom: '4px' }}>
                            <Typography variant="body2">
                                <Link href={item.link} target="_blank" rel="noopener noreferrer">
                                    {item.name}
                                </Link>
                            </Typography>
                        </ListItem>
                    ))}
                </List>
            </Box>

            {/* 現在の所属学生と研究テーマ */}
            <Box mb={4}>
                <Typography variant="h6" gutterBottom>
                    Current Students and Research Themes
                </Typography>
                <List>
                    {currentStudents.map((student, index) => (
                        <ListItem key={index} sx={{ padding: 0, marginBottom: '4px' }}>
                            <Typography variant="body2">
                                {student.name} ({student.degree}): {student.theme}
                            </Typography>
                        </ListItem>
                    ))}
                </List>
            </Box>

            {/* Master Thesis */}
            <Box mb={4}>
                <Typography variant="h6" gutterBottom>
                    Master Thesis
                </Typography>
                <List>
                    {masterAlumni.map((alum, index) => (
                        <ListItem key={index} sx={{ padding: 0, marginBottom: '4px' }}>
                            <Typography variant="body2">
                                {alum.name} ({alum.year}) - {alum.theme}
                                {alum.thesisLink && (
                                    <> -{' '}
                                    <Link href={alum.thesisLink} target="_blank" rel="noopener noreferrer">
                                        View Thesis
                                    </Link>
                                    </>
                                )}
                            </Typography>
                        </ListItem>
                    ))}
                </List>
            </Box>

            {/* Graduation Thesis */}
            <Box mb={4}>
                <Typography variant="h6" gutterBottom>
                    Graduation Thesis
                </Typography>
                <List>
                    {bachelorAlumni.map((alum, index) => (
                        <ListItem key={index} sx={{ padding: 0, marginBottom: '4px' }}>
                            <Typography variant="body2">
                                {alum.name} ({alum.year}) - {alum.theme}
                                {alum.thesisLink && (
                                    <> -{' '}
                                    <Link href={alum.thesisLink} target="_blank" rel="noopener noreferrer">
                                        View Thesis
                                    </Link>
                                    </>
                                )}
                            </Typography>
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Container>
    );
}

export default Education;